import * as api from "../../api/TamtamAPI/webinarStats";
import { pushSourceToken } from "utils";

export const getCategorieDevice = function (params) {
    return function (dispatch, getState) {
        var sourceToken = pushSourceToken("GET_CATEGORIE_DEVICE", dispatch);
        var token = getState().auth.token;
        return api.getCategorieDevice(token, params, sourceToken);
    };
};

export const getStatsOverview = function (issuerId, params) {
    return function (dispatch, getState) {
        var sourceToken = pushSourceToken("GET_STATS_OVERVIEW", dispatch);
        var token = getState().auth.token;
        return api.getStatsOverview(token, issuerId, params, sourceToken);
    };
};

export const getBestTraining = function (issuerId, params) {
    return function (dispatch, getState) {
        var sourceToken = pushSourceToken("GET_BEST_TRAINING", dispatch);
        var token = getState().auth.token;
        return api.getBestTraining(token, issuerId, params, sourceToken);
    };
};

export const getFormatRanking = function (issuerId, params) {
    return function (dispatch, getState) {
        const sourceToken = pushSourceToken("GET_FORMAT_RANKING", dispatch);
        const token = getState().auth.token;
        return api.getFormatRanking(token, issuerId, params, sourceToken);
    };
};

export const getSpeakers = function (issuerId, params) {
    return function (dispatch, getState) {
        const sourceToken = pushSourceToken("GET_SPEAKERS", dispatch);
        const token = getState().auth.token;
        return api.getSpeakers(token, issuerId, params, sourceToken);
    };
};

export const getLocalisation = function (issuerId, params) {
    return function (dispatch, getState) {
        const sourceToken = pushSourceToken("GET_LOCALISATION", dispatch);
        const token = getState().auth.token;
        return api.getLocalisation(token, issuerId, params, sourceToken);
    };
};


// WEBPACK FOOTER //
// ./app/actions/thunks/webinarStats.js